import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3bebb126")

_pushScopeId("data-v-3bebb126")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "form-tip" }, "请确认企业名称", -1)
const _hoisted_2 = { class: "import-actions" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "import-tip" }, "请正确选择设备型号，如出错，请重新导入。相同设备型号会更新", -1)
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("确 定")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_cascader = _resolveComponent("el-cascader")
  const _component_c_upload = _resolveComponent("c-upload")
  const _component_c_export_file = _resolveComponent("c-export-file")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "代导入车载设备",
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.visible = $event)),
    "close-on-click-modal": false,
    width: "600px",
    onClose: _ctx.handleCloseDialog
  }, {
    footer: _withId(() => [
      _createVNode("span", _hoisted_4, [
        _createVNode(_component_el_button, { onClick: _ctx.handleCloseDialog }, {
          default: _withId(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.handleCloseDialog
        }, {
          default: _withId(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withId(() => [
      _createVNode(_component_el_form, {
        model: _ctx.formData,
        rules: _ctx.rules,
        "label-width": "90px",
        ref: "ruleForm"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            label: "选择企业",
            prop: "companyUuid"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.companyUuid,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.companyUuid = $event)),
                class: "company-select",
                placeholder: "请输入",
                clearable: "",
                filterable: "",
                remote: "",
                "remote-method": _ctx.remoteData1.remoteMethod,
                loading: _ctx.remoteData1.isLoading
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.remoteData1.options, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "remote-method", "loading"]),
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "设备型号",
            prop: "deviceMaintainUuid"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_cascader, {
                modelValue: _ctx.formData.deviceMaintainUuid,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.deviceMaintainUuid = $event)),
                props: _ctx.cascaderProps,
                placeholder: "请选择",
                clearable: ""
              }, null, 8, ["modelValue", "props"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "导入设备" }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_2, [
                _createVNode(_component_c_upload, {
                  action: _ctx.importAction,
                  headers: _ctx.uploadHeaders,
                  data: _ctx.uploadData,
                  multiple: false,
                  accept: ".xlsx",
                  limit: 1,
                  maxSize: 3072,
                  "btn-text": "上传模板文件",
                  "is-tip": false,
                  "success-tip": "",
                  disabled: !_ctx.formData.companyUuid || !_ctx.formData.deviceMaintainUuid,
                  onOnSuccess: _ctx.onUploadSuccess,
                  onOnRemove: _ctx.onUploadRemove
                }, null, 8, ["action", "headers", "data", "disabled", "onOnSuccess", "onOnRemove"]),
                _createVNode(_component_c_export_file, {
                  class: "download-btn",
                  url: "/device/terminal/importTemplate",
                  "btn-type": "text",
                  "btn-text": "下载模板文件",
                  "btn-icon": "",
                  "file-title": _ctx.importFileName,
                  "file-type": "xlsx",
                  "is-confirm": false
                }, null, 8, ["file-title"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _hoisted_3
    ]),
    _: 1
  }, 8, ["modelValue", "onClose"]))
})